import { render, staticRenderFns } from "./ModalNotificacao.vue?vue&type=template&id=502c4f30"
import script from "./ModalNotificacao.vue?vue&type=script&lang=js"
export * from "./ModalNotificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports